export const licenseConstants = {
  LICENSE_CREATION_REQUEST: 'LICENSE_CREATION__REQUEST',
  LICENSE_CREATION_SUCCESS: 'LICENSE_CREATION_SUCCESS',
  LICENSE_CREATION_FAILURE: 'LICENSE_CREATION_FAILURE',

  LICENSE_GETALL_REQUEST: 'LICENSES_GETALL_REQUEST',
  LICENSE_GETALL_SUCCESS: 'LICENSES_GETALL_SUCCESS',
  LICENSE_GETALL_FAILURE: 'LICENSES_GETALL_FAILURE',

  LICENSE_UPDATE_REQUEST: 'LICENSES_UPDATE_REQUEST',
  LICENSE_UPDATE_SUCCESS: 'LICENSES_UPDATE_SUCCESS',
  LICENSE_UPDATE_FAILURE: 'LICENSES_UPDATE_FAILURE',

  LICENSE_GETALL_USER_REQUEST: 'LICENSE_GETALL_USER_REQUEST',
  LICENSE_GETALL_USER_SUCCESS: 'LICENSE_GETALL_USER_SUCCESS',
  LICENSE_GETALL_USER_FAILURE: 'LICENSE_GETALL_USER_FAILURE',

  LICENSE_EXPORT_REQUEST: 'LICENSE_EXPORT_REQUEST',
  LICENSE_EXPORT_SUCCESS: 'LICENSE_EXPORT_SUCCESS',
  LICENSE_EXPORT_FAILURE: 'LICENSE_EXPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/constants/license.constants.js